/* eslint-disable max-len */
export const HANDLE_ERROR = 'HANDLE_ERROR'
export const UPDATE_STATE = 'UPDATE_STATE'
